import { Component } from "@angular/core";
import {
  AppConfigService,
  ConfigurationPolicyCompleteDTO
} from "@core/services/app-config.service";
import { assetUrl } from "@shared/helper/asset-url";
import { Observable } from "rxjs";

@Component({
  selector: "app-dynamic-loading-driveb",
  templateUrl: "./dynamic-loading-driveb.component.html",
  styleUrls: ["./dynamic-loading-driveb.component.scss"],
  standalone: false
})
export class DynamicLoadingDrivebComponent {
  icon$: string;
  config$: Observable<ConfigurationPolicyCompleteDTO>;

  constructor(private configService: AppConfigService) {
    this.getLoadingIcon();
    this.config$ = this.configService.getConfig$();
  }

  private getLoadingIcon() {
    this.icon$ = assetUrl("img/favicon/favicon.png");
  }
}
